// @flow

import React from 'react'
import styled from 'styled-components'
import ErrorMessage from './ErrorMessage'
import Radio from './Radio'
import BigFieldLabel from './BigFieldLabel'
import type { IFormFieldChoice } from '../../../../entities/types'
import { colorPalette } from '../../../../styles/styleGuide'

type RadioGroupProps = {
  name: string
  title: string
  onChange: () => void
  required?: boolean
  choices: Array<IFormFieldChoice>
  isValid?: boolean
  validationMessage?: string
  type: string
  defaultValue: string | number
  hasIcons?: boolean
}

const defaultProps = {}

const RadioGroupChoices = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-right: -15rem;

  > div {
    margin-top: 10rem;
    margin-right: 30rem;
  }
`

const RadioGroupHint = styled.span`
  font-size: 12rem;
  color: ${colorPalette.beige};
`

const RadioGroup = ({
  title,
  choices = [],
  type,
  required = false,
  name,
  validationMessage,
  isValid,
  defaultValue,
  onChange,
  hasIcons,
}: RadioGroupProps) => {
  return (
    <>
      {title && (
        <>
          <BigFieldLabel
            label={title}
            required={required}
          />
          {type === 'radiogroup' && hasIcons && (
            <RadioGroupHint>Slechts één antwoord mogelijk</RadioGroupHint>
          )}
        </>
      )}
      <RadioGroupChoices>
        {choices.length > 0 &&
          choices.map((option) => {
            return hasIcons ? (
              <Radio
                key={option.key}
                id={option.key}
                name={name}
                label={option.key ?? option.value}
                type={type}
                value={option.value}
                defaultChecked={option.value === defaultValue}
                required={required}
                onChange={onChange}
                disabled={option.disabled ?? false}
                hasIcons={hasIcons}
                icon={option.icon}
              />
            ) : (
              <Radio
                key={option.key}
                id={option.key}
                name={name}
                label={option.key ?? option.value}
                type={type}
                value={option.value}
                defaultChecked={option.value === defaultValue}
                required={required}
                onChange={onChange}
                disabled={option.disabled ?? false}
              />
            )
          })}
      </RadioGroupChoices>

      {validationMessage && (
        <ErrorMessage
          isValid={isValid}
          message={validationMessage}
        />
      )}
    </>
  )
}

RadioGroup.defaultProps = defaultProps

export default RadioGroup
